import { Row, Col } from "antd";
import CustomInput from "../../../components/CustomInput/Input";
import {
  getApobRules,
  address1Rules,
  address2Rules,
  cityRules,
  stateRules,
  pincodeRules,
} from "../../../helpers/helpers";

const PocApobAddressFields = () => {
  return (
    <>
      <CustomInput
        name="apob"
        label="Additional Place of Business (APOB)"
        isRequired
        placeholder="e.g. Bengaluru Plant Unit 2"
        rules={getApobRules({ required: true, label: "APOB" })}
      />

      <Row gutter={16}>
        <Col span={12}>
          <CustomInput
            name={["address", "addressLine1"]}
            label="Address Line 1"
            isRequired
            placeholder="Plot/Building/Street"
            rules={address1Rules}
          />
        </Col>
        <Col span={12}>
          <CustomInput
            name={["address", "addressLine2"]}
            label="Address Line 2"
            placeholder="Suite/Landmark/Area"
            rules={address2Rules.filter((rule) => !rule.required)}
          />
        </Col>
        <Col span={8}>
          <CustomInput
            name={["address", "city"]}
            label="City"
            isRequired
            allowLettersOnly
            placeholder="City"
            rules={cityRules}
          />
        </Col>
        <Col span={8}>
          <CustomInput
            name={["address", "state"]}
            label="State"
            isRequired
            allowLettersOnly
            placeholder="State"
            rules={stateRules}
          />
        </Col>
        <Col span={8}>
          <CustomInput
            name={["address", "pinCode"]}
            label="PIN Code"
            isRequired
            allowNumbersOnly
            placeholder="6-digit PIN"
            maxLength={6}
            rules={pincodeRules}
          />
        </Col>
      </Row>
    </>
  );
};

export default PocApobAddressFields;
